import { Chip, Typography } from '@mui/material'
import { FC } from 'react'

interface ProjectStatusTagProps{
    status:boolean
}

export const ProjectStatusTag: FC<ProjectStatusTagProps> = ({status}) => {
  return (
    <Chip
      color="primary"
      variant="outlined"
      sx={{
        my: '.2rem',
        padding: '8px 4px',
        borderRadius: '24px',
        alignSelf: 'flex-end',
        border: 'transparent',
        backgroundColor: status ? 'primary.light' : 'error.light',
      }}
      label={
        <Typography
          variant="body1"
          sx={{ color: status ? 'primary.main' : 'error.main', fontSize: '0.875rem' }}
        >
          {status ? 'Active' : 'Complete'}
        </Typography>
      }
    />
  )
}
